module.exports = __webpack_public_path__ + "static/media/map.d9ebe2cb.avif";